export default __webpack_public_path__ + "static/media/slack.0b6bfe90.svg";